import type { InputHTMLAttributes, ReactElement } from 'react';

export interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export function TextField({
  className,
  invalid,
  'aria-invalid': ariaInvalid,
  ...props
}: TextFieldProps): ReactElement {
  return (
    <input
      {...props}
      className={['cards-kit-text-field', className].filter(Boolean).join(' ')}
      aria-invalid={invalid ?? ariaInvalid}
      data-invalid={invalid === true ? 'true' : undefined}
    />
  );
}
